import { ButtonMinus } from './ButtonMinus';

export { ButtonMinus } from './ButtonMinus';

export default ButtonMinus;
